import type { FaireProductEntity } from "../../entity_types/product";

export const p_rwuemcryd2: FaireProductEntity = {
  token: "p_rwuemcryd2",
  type: "product",
  name: "Vintage Simple Elegant Rhinestone Rings DPJR1422",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Dipped Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/0ffb5ae29f1ddccd3ec8799dae0d2121d0f0719f5acd3bd6a7cf390a2f81334a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5fcd0527f286387cc1415118e03fb469d7c8271187f06a9824987b8b2956adca.jpeg",
    "https://cdn.faire.com/fastly/f4fa1771f4d9b5f400e866b4acc489892962e673ff6fb35d835bf86ec7114dd9.jpeg",
    "https://cdn.faire.com/fastly/ec5a0d91ade6a5be4575acfa887f073bf441f5558fa407794177be5d8f33e85d.jpeg",
    "https://cdn.faire.com/fastly/2dcee3a6d1a36dec52abea8e4fedda4135048ace4904b2cff25eb8d2857caf3d.jpeg",
    "https://cdn.faire.com/fastly/6978ced16f86e8f938406bace9e10b2f86f79c3782afb665377dbb7374b07dd4.jpeg",
    "https://cdn.faire.com/fastly/c9439be7e84c4514965878a796ab857f55503cfa341f9d80c1e7c4b87531e31d.jpeg",
    "https://cdn.faire.com/fastly/5fda78bc09c1825de2b2e07ec115b0de0717bc1a58bdf38a672560339d478570.jpeg",
    "https://cdn.faire.com/fastly/e6bbe056833897e9e52eabdce945e952dbca2ea4525babbf76e3ac5d1a49f805.jpeg",
    "https://cdn.faire.com/fastly/88689dc2ed742988d6049e38a99ca19e5238d3d6c0335ad1b487e7ba8787bc13.jpeg",
  ],
  priceDollars: 9.01,
  description:
    "Feature:\n * Vintage\n * Elegant\n * Layered\n * Rhinestone\n\n Weigh:\n * 3.5g\n\n Material:\n * Copper\n\n Package:\n * Package include 1 * ring.\n\n Note: See picture labels (size and weight are hand-measured there will be a small error, specific in kind shall prevail, please note the size before purchase) ",
  tags: [],
  msrpDollars: 23.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:54.237Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
